import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { LayoutDashboard, Users, Calendar, FileText, Sparkles, LogOut, Shield, Ticket, DollarSign, Mail, Film, Mic } from "lucide-react";
import api from "@/lib/api";

export default function AdminShell() {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);

  useEffect(() => {
    (async () => {
      try { const r = await api.get("/admin/me"); setMe(r.data); }
      catch { navigate("/admin/login"); }
    })();
  }, [navigate]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    navigate("/admin/login");
  };

  if (!me) return <div className="min-h-screen grid place-items-center"><div className="h-10 w-10 rounded-full border-2 border-[hsl(var(--accent))] border-t-transparent animate-spin" /></div>;

  const linkCls = ({ isActive }) => `flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-[hsl(var(--accent))]/12 text-[hsl(var(--accent))]" : "text-[hsl(var(--muted-foreground))] hover:bg-[hsl(var(--muted))]"}`;

  return (
    <div className="min-h-screen bg-[hsl(var(--background))] grid grid-cols-[220px_1fr]">
      <aside className="border-r border-[hsl(var(--border))] bg-[hsl(var(--card))] p-4 flex flex-col" data-testid="admin-sidebar">
        <div className="px-2 py-1 flex items-center gap-2">
          <Shield size={16} className="text-[hsl(var(--accent))]" />
          <span className="font-display font-semibold text-sm">Admin</span>
        </div>
        <nav className="mt-6 space-y-1">
          <NavLink to="/admin" end className={linkCls} data-testid="admin-nav-dashboard"><LayoutDashboard size={15} /> Dashboard</NavLink>
          <NavLink to="/admin/users" className={linkCls} data-testid="admin-nav-users"><Users size={15} /> Users</NavLink>
          <NavLink to="/admin/events" className={linkCls} data-testid="admin-nav-events"><Calendar size={15} /> Events</NavLink>
          <NavLink to="/admin/queue" className={linkCls} data-testid="admin-nav-queue"><Film size={15} /> Compile queue</NavLink>
          <NavLink to="/admin/coupons" className={linkCls} data-testid="admin-nav-coupons"><Ticket size={15} /> Coupons</NavLink>
          <NavLink to="/admin/pricing" className={linkCls} data-testid="admin-nav-pricing"><DollarSign size={15} /> Pricing</NavLink>
          <NavLink to="/admin/emails" className={linkCls} data-testid="admin-nav-emails"><Mail size={15} /> Emails</NavLink>
          <NavLink to="/admin/settings" className={linkCls} data-testid="admin-nav-settings"><Mic size={15} /> Voice & keys</NavLink>
          <NavLink to="/admin/audit" className={linkCls} data-testid="admin-nav-audit"><FileText size={15} /> Audit log</NavLink>
          <NavLink to="/admin/ai" className={linkCls} data-testid="admin-nav-ai"><Sparkles size={15} /> AI helper</NavLink>
        </nav>
        <div className="mt-auto pt-4 border-t border-[hsl(var(--border))] text-xs text-[hsl(var(--muted-foreground))]">
          <div className="font-semibold text-[hsl(var(--foreground))] truncate">{me.name || me.email}</div>
          <div className="truncate">{me.email}</div>
          <div className="mt-1 inline-flex px-2 py-0.5 rounded-full bg-[hsl(var(--muted))] text-[10px] uppercase tracking-wide font-semibold">{me.role.replace("_", " ")}</div>
          <button onClick={logout} data-testid="admin-logout" className="mt-3 inline-flex items-center gap-1.5 px-2 py-1 rounded-md hover:bg-[hsl(var(--muted))]"><LogOut size={13} /> Sign out</button>
        </div>
      </aside>
      <main className="overflow-y-auto">
        <Outlet context={{ me }} />
      </main>
    </div>
  );
}
